import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const resolveIncident = {
  name: "resolveIncident" as const,
  input: z.object({ incidentId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
